<template>
  <div class="block-result">
    <div class="head">
      <div class="title">{{ $tr('responses.tabs.bcg-test.category.label', {category: category.category}) }}</div>
      <div
        class="status"
        :class="{ failed: !category.is_passed }">{{ $tr('responses.tabs.bcg-test.status.' + (category.is_passed ? 'completed' : 'failed')) }}</div>
    </div>
    <div class="item">
      <div class="sub-title">{{ $tr('responses.tabs.bcg-test.block.threshold') }}</div>
      <div class="value"> {{ category.min_points_threshold }}</div>
    </div>
    <div class="item">
      <div class="sub-title">{{ $tr('responses.tabs.bcg-test.block.typed') }}</div>
      <div class="value"> {{ category.points_received }}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'bcg-response-tab-test-category',
    props: {
      category: {
        type: Object,
        required: true,
      }
    }
  }
</script>
<style scoped lang="scss">
  .block-result {
    padding: 5px 0;
    margin: 5px 0;
    border-bottom: 1px solid #d7d7d7;
    .head {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      color: #000000;
      white-space: nowrap;
      margin-bottom: 10px;
      font-weight: 500;
      .status {
        &.failed {
          color: $btn-red;
        }
      }
    }
    .item {
      display: flex;
      justify-content: flex-start;
      margin: 5px 0;
      .sub-title {
        font-weight: 500;
        margin-right: 5px;
      }
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
</style>
